<template>
  <div>
    <div class="loader" v-if="this.isLoading"></div>
    <div class="loadertext" v-if="this.isLoading"> {{ $t('loadingTxt') }}...</div>
    <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">

      <!--begin::navbar-->
      <navbar-component></navbar-component>
      <!--end::navbar-->

      <div class="page-wrapper">

        <!--begin::content-->
        <div class="page-content">
          <div class="row">
            <div class="col-lg-12 col-xl-12 col-sm-12 col-xs-12 col-md-12">
              <div class="card">
                <div class="card-header">
                  <!-- <i class="link-icon float-start" data-feather="arrow-left"></i> -->
                  &nbsp;&nbsp;&nbsp;
                  <h6 class="card-title mt-2 float-start" style="padding-left: 25px">Detail ASN | Doc No : {{
                    forms.docNo }} | Status :
                    <span class="badge bg-danger"
                      v-if="forms.orderStatus == 'CANCELLED' || forms.orderStatus == 'SYNC FAILED'">{{ forms.orderStatus
                      }}</span>
                    <span class="badge bg-secondary" v-else-if="forms.orderStatus == 'DRAFT'">{{ forms.orderStatus
                    }}</span>
                    <span class="badge bg-info" v-else>{{ forms.orderStatus }}</span>
                  </h6>
                  <!-- <button class="btn btn-default btn-sm float-end" @click="resetForm" type="button">
                    <i class="link-icon" data-feather="repeat"></i>
                    {{ $t("resetFormTxt") }}
                  </button> -->

                  <button class="btn btn-danger btn-sm float-end" @click="orderTracking" type="button">
                    <!-- <i class="link-icon" data-feather="track"></i> -->
                    ASN Status Tracking
                  </button>
                </div>
                <div class="card-body">

                  <form class="forms-sample" @submit.prevent="submitData" method="ASNST">


                    <ul class="nav nav-tabs nav-tabs-line" id="lineTab" role="tablist">
                      <li class="nav-item">
                        <a class="nav-link active" id="home-line-tab" data-bs-toggle="tab" href="#home" role="tab"
                          aria-controls="home" aria-selected="true">Main Info</a>
                      </li>
                      <li class="nav-item">
                        <a class="nav-link" id="supplier-line-tab" data-bs-toggle="tab" href="#supplier" role="tab"
                          aria-controls="supplier" aria-selected="false">Supplier</a>
                      </li>

                      <li class="nav-item">
                        <a class="nav-link" readonly id="userDefine-line-tab" data-bs-toggle="tab" href="#userDefine" role="tab"
                          aria-controls="disabled" aria-selected="false">User Defined</a>
                      </li>

                      <li class="nav-item">
                        <a class="nav-link" id="other-line-tab" data-bs-toggle="tab" href="#other" role="tab"
                          aria-controls="disabled" aria-selected="false">Other</a>
                      </li>

                    </ul>
                    <div class="tab-content mt-3" id="lineTabContent">
                      <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-line-tab">

                        <div class="row mb-2">
                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label required">{{
                              $t('customerId')
                            }}</label>

                            <v-select disabled :options="fetchCustomer" v-model="customer" label="code" return-object
                              @search="asyncCustomer">
                              <template slot="option" slot-scope="option">
                                {{ option.code }} | {{ option.name }}
                              </template>
                            </v-select>

                            <div v-if="errors.customerId">
                              <div v-for="error in errors.customerId" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>

                          </div>
                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label required">Warehouse Id</label>

                            <v-select disabled :options="fetchFulfillment" v-model="fulfillment" label="code"
                              return-object @search="asyncSearchFulfillment">
                              <template slot="option" slot-scope="option">
                                {{ option.code }} | {{ option.name }}
                              </template>
                            </v-select>


                            <div v-if="errors.fulfillment_center_id">
                              <div v-for="error in errors.fulfillment_center_id" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>

                          </div>
                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label required">ASN Type</label>

                            <v-select disabled :options="fetchAsnType" v-model="asnType" label="name" return-object>
                              <!-- <template slot="option" slot-scope="option">
                  {{ option.customer_id}} | {{option.code}} | {{option.name}}
            </template> -->
                            </v-select>
                            <div v-if="errors.asnType">
                              <div v-for="error in errors.asnType" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>

                          </div>

                        </div>

                        <div class="row mb-2">
                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label">ASN Reference A</label>
                            <input readonly type="text" class="form-control" id="asnReferenceA" placeholder=""
                              v-model="forms.asnReferenceA" />
                            <div v-if="errors.asnReferenceA">
                              <div v-for="error in errors.asnReferenceA" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label">ASN Reference B</label>
                            <input readonly type="text" class="form-control" id="asnReferenceB" placeholder=""
                              v-model="forms.asnReferenceB" />
                            <div v-if="errors.asnReferenceB">
                              <div v-for="error in errors.asnReferenceB" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label">ASN Reference C</label>
                            <input readonly type="text" class="form-control" id="asnReferenceC" placeholder=""
                              v-model="forms.asnReferenceC" />
                            <div v-if="errors.asnReferenceC">
                              <div v-for="error in errors.asnReferenceC" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label">ASN Reference D</label>
                            <input readonly type="text" class="form-control" id="asnReferenceD" placeholder=""
                              v-model="forms.asnReferenceD" />
                            <div v-if="errors.asnReferenceD">
                              <div v-for="error in errors.asnReferenceD" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                        </div>

                        <div class="row mb-2">



                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label required">Doc No</label>
                            <input type="text" readonly class="form-control" id="docNo" placeholder="Doc No"
                              v-model="forms.docNo" />
                            <div v-if="errors.docNo">
                              <div v-for="error in errors.docNo" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label required">Delivery Vehicle No</label>
                            <input type="text" readonly class="form-control" id="deliveryVehicleNo"
                              placeholder="Delivery Vehicle No" v-model="forms.deliveryVehicleNo" />
                            <div v-if="errors.deliveryVehicleNo">
                              <div v-for="error in errors.deliveryVehicleNo" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label required">ASN Time</label>
                            <input readonly  type="text" class="form-control" id="asnNo" placeholder="ASN Time"
                              v-model="this.forms.asnCreationTime" />
                            <div v-if="errors.asnCreationTime">
                              <div v-for="error in errors.asnCreationTime" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>

                          </div>
                          <div class="col-lg-3">

                            <label for="defaultconfig" class="col-form-label">Expected Shipment Time</label>
                            <input readonly  type="text" class="form-control" id="docNo" placeholder="Doc No"
                              v-model="this.forms.expectedArriveTime1" />
                            <div v-if="errors.expectedArriveTime1">
                              <div v-for="error in errors.expectedArriveTime1" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>

                          </div>




                        </div>

                        <div class="row mb-2">

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label required">Driver</label>
                            <input type="text" readonly class="form-control" id="driver" placeholder="Driver"
                              v-model="forms.driver" />
                            <div v-if="errors.driver">
                              <div v-for="error in errors.driver" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label required">Delivery Vehicle No</label>
                            <input type="text" readonly class="form-control" id="deliveryVehicleNo"
                              placeholder="Delivery Vehicle No" v-model="forms.deliveryVehicleNo" />
                            <div v-if="errors.deliveryVehicleNo">
                              <div v-for="error in errors.deliveryVehicleNo" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Total Cubic</label>
                            <input type="number" readonly class="form-control" id="totalCubic" placeholder=""
                              v-model="forms.totalCubic" />
                            <div v-if="errors.totalCubic">
                              <div v-for="error in errors.totalCubic" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Total Gross Weight</label>
                            <input type="text" readonly class="form-control" id="totalGrossWeight" placeholder=""
                              v-model="forms.totalGrossWeight" />
                            <div v-if="errors.totalGrossWeight">
                              <div v-for="error in errors.totalGrossWeight" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>
                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Total Net Weight</label>
                            <input type="number" readonly class="form-control" id="totalNetWeight" placeholder=""
                              v-model="forms.totalNetWeight" />
                            <div v-if="errors.totalNetWeight">
                              <div v-for="error in errors.totalNetWeight" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Total Price</label>
                            <input type="number" readonly class="form-control" id="totalPrice" placeholder=""
                              v-model="forms.totalPrice" />
                            <div v-if="errors.totalPrice">
                              <div v-for="error in errors.totalPrice" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                        </div>

                        <!--<div class="row mb-2">
        <div class="col-lg-2">
          <label for="defaultconfig" class="col-form-label">Route</label>
          <input readonly  type="text" class="form-control" id="route" placeholder="Route"
            v-model="forms.route" />
          <div v-if="errors.route">
            <div v-for="error in errors.route" :key="error" class="alert alert-primary" role="alert">
              <i data-feather="alert-circle"></i>
              {{ error }}
            </div>
          </div>

        </div>
        <div class="col-lg-2">
          <label for="defaultconfig" class="col-form-label">Stop Station</label>
          <input readonly  type="text" class="form-control" id="stopStation" placeholder="Stop Station"
            v-model="forms.stopStation" />
          <div v-if="errors.stopStation">
            <div v-for="error in errors.stopStation" :key="error" class="alert alert-primary"
              role="alert">
              <i data-feather="alert-circle"></i>
              {{ error }}
            </div>
          </div>

        </div>
    </div>-->


                        <div class="row mb-2">
                          <div class="col-lg-12">
                            <label for="defaultconfig" class="col-form-label">Note</label>
                            <textarea disabled class="form-control" name="noteTxt" v-model="forms.noteText"></textarea>
                            <div v-if="errors.noteText">
                              <div v-for="error in errors.noteText" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>

                          </div>
                        </div>

                        <div class="row card mt-5">
                          <div class="card-header">
                            <h5 class="float-start">Detail <span class="wajib">*</span></h5>

                            <!-- <button class="
        btn btn-success btn-icon
        text-white
        fw-bolder
        btn-icon-text
        float-end
      " @click="addFieldDetail()" type="button"> <i class="link-icon" data-feather="plus"></i>
                            </button> -->

                          </div>

                          <div class="card-body">
                            <div class="table-responsive">
                              <table class="table table-hover" style="height: 300px">
                                <thead>

                                  <tr>
                                    <th>#</th>
                                    <th width="450px" class="required">SKU</th>
                                    <th width="150px">SKU Description</th>
                                    <th class="required">Qty Order</th>
                                    <th class="required">Qty Received</th>
                                    <th>Uom</th>
                                    <th>Total Cubix</th>
                                    <th>Total Gross Weight</th>
                                    <th>Total Net Weight</th>
                                    <th>Total Price</th>
                                    <th>Price</th>
                                    <th>LotAtt01</th>
                                    <th>LotAtt02</th>
                                    <th>LotAtt03</th>
                                    <th>LotAtt04</th>
                                    <th>LotAtt05</th>
                                    <th>lotAtt06</th>
                                    <th>LotAtt07</th>
                                    <th>LotAtt08</th>
                                    <th>LotAtt09</th>
                                    <th>LotAtt10</th>
                                    <th>LotAtt11</th>
                                    <th>LotAtt12</th>
                                    <th>LotAtt13</th>
                                    <th>LotAtt14</th>
                                    <th>LotAtt15</th>
                                    <th>LotAtt16</th>
                                    <th>LotAtt17</th>
                                    <th>LotAtt18</th>
                                    <th>LotAtt19</th>
                                    <th>LotAtt20</th>
                                    <th>LotAtt21</th>
                                    <th>LotAtt22</th>
                                    <th>LotAtt23</th>
                                    <th>LotAtt24</th>
                                    <th>Dedi01</th>
                                    <th>Dedi02</th>
                                    <th>Dedi03</th>
                                    <th>Dedi04</th>
                                    <th>Dedi05</th>
                                    <th>Dedi06</th>
                                    <th>Dedi07</th>
                                    <th>Dedi08</th>
                                    <th>Dedi09</th>
                                    <th>Dedi10</th>
                                    <th>Dedi11</th>
                                    <th>Dedi12</th>
                                    <th>Dedi13</th>
                                    <th>Dedi14</th>
                                    <th>Dedi15</th>
                                    <th>Dedi16</th>
                                    <th>Dedi17</th>
                                    <th>Dedi18</th>
                                    <th>Dedi19</th>
                                    <th>Dedi20</th>
                                    <th>Note Text</th>
                                    <th>Container Id</th>
                                    <th>UDF 01</th>
                                    <th>UDF 02</th>
                                    <th>UDF 03</th>
                                    <th>UDF 04</th>
                                    <th>UDF 05</th>
                                    <th>UDF 06</th>

                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(input, index) in this.detailAsn" :key="`phoneInput-${index}`">
                                    <th>{{ index + 1 }}</th>

                                    <td width="200px">


                                      <!-- <multiselect style="width:200px;" @search-change="asyncSearchSku"
                                        v-model="input.sku" :options="fetchSku" @input="cekData(index, detailAsn)"
                                        label="sku" track-by="sku" placeholede="Please Select SKU">
                                        <span slot="noResult">Oops! No elements found. Consider changing the
                                          search query.</span>
                                      </multiselect> -->
                                      {{ input.sku }}

                                    </td>

                                    <td>

                                      {{ input.skuDescr }}
                                      <!-- <input readonly  type="number" v-model="input.volume" class="form-control" style="width: 100px" /> -->
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="number" v-model="input.orderedQty" class="form-control" required
                                        style="width: 100px" /> -->
                                      {{ input.expectedQty }}
                                    </td>


                                    <td>
                                      <!-- <input readonly  type="number" v-model="input.orderedQty" class="form-control" required
                                        style="width: 100px" /> -->
                                      {{ input.receivedQty }}
                                    </td>

                                    


                                    <td>
                                      <!-- <input readonly  type="number" v-model="input.totalCubic" class="form-control"
                                        style="width: 100px" /> -->

                                      {{ input.packUom }}
                                    </td>
                                    <td>
                                      <!-- <input readonly  type="number" v-model="input.totalCubic" class="form-control"
                                        style="width: 100px" /> -->

                                      {{ input.totalCubic }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="number" v-model="input.totalGrossWeight" class="form-control"
                                        style="width: 100px" /> -->
                                      {{ input.totalGrossWeight }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="number" v-model="input.totalNetWeight" class="form-control"
                                        style="width: 100px" /> -->
                                      {{ input.totalNetWeight }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="number" v-model="input.totalPrice" class="form-control"
                                        style="width: 100px" /> -->
                                      {{ input.totalPrice }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="number" v-model="input.price" class="form-control"
                                        style="width: 100px" /> -->
                                      {{ input.price }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt01" class="form-control"
                                        style="width: 100px" /> -->
                                      {{ input.lotAtt01 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt02" class="form-control"
                                        style="width: 100px" /> -->
                                      {{ input.lotAtt02 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt03" class="form-control"
                                        style="width: 100px" /> -->
                                      {{ input.lotAtt03 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt04" class="form-control"
                                        style="width: 100px" /> -->
                                      {{ input.lotAtt04 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt05" class="form-control"
                                        style="width: 100px" /> -->
                                      {{ input.lotAtt05 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt06" class="form-control"
                                        style="width: 100px" /> -->
                                      {{ input.lotAtt06 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt07" class="form-control"
                                        style="width: 100px" /> -->

                                      {{ input.lotAtt07 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt08" class="form-control"
                                        style="width: 100px" /> -->
                                      {{ input.lotAtt08 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt09" class="form-control"
                                        style="width: 100px" /> -->
                                      {{ input.lotAtt09 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt10" class="form-control"
                                        style="width: 100px" /> -->

                                      {{ input.lotAtt10 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt11" class="form-control"
                                        style="width: 100px" /> -->

                                      {{ input.lotAtt11 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt12" class="form-control"
                                        style="width: 100px" /> -->

                                      {{ input.lotAtt12 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt13" class="form-control"
                                        style="width: 100px" /> -->

                                      {{ input.lotAtt13 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt14" class="form-control"
                                        style="width: 100px" /> -->

                                      {{ input.lotAtt14 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt15" class="form-control"
                                        style="width: 100px" /> -->
                                      {{ input.lotAtt15 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt16" class="form-control"
                                        style="width: 100px" /> -->
                                      {{ input.lotAtt16 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt17" class="form-control"
                                        style="width: 100px" /> -->
                                      {{ input.lotAtt17 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt18" class="form-control"
                                        style="width: 100px" /> -->
                                      {{ input.lotAtt18 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt19" class="form-control"
                                        style="width: 100px" /> -->{{ input.lotAtt19 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt20" class="form-control"
                                        style="width: 100px" /> --> {{ input.lotAtt20 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt21" class="form-control"
                                        style="width: 100px" /> --> {{ input.lotAtt21 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt22" class="form-control"
                                        style="width: 100px" /> --> {{ input.lotAtt22 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt23" class="form-control"
                                        style="width: 100px" /> --> {{ input.lotAtt23 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.lotAtt24" class="form-control"
                                        style="width: 100px" /> --> {{ input.lotAtt24 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.dedi01" class="form-control"
                                        style="width: 100px" /> --> {{ input.dedi01 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.dedi02" class="form-control"
                                        style="width: 100px" /> -->

                                      {{ input.dedi02 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.dedi03" class="form-control"
                                        style="width: 100px" /> --> {{ input.dedi03 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.dedi04" class="form-control"
                                        style="width: 100px" /> --> {{ input.dedi04 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.dedi05" class="form-control"
                                        style="width: 100px" /> --> {{ input.dedi05 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.dedi06" class="form-control"
                                        style="width: 100px" /> --> {{ input.dedi06 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.dedi07" class="form-control"
                                        style="width: 100px" /> --> {{ input.dedi07 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.dedi08" class="form-control"
                                        style="width: 100px" /> --> {{ input.dedi08 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="number" v-model="input.dedi09" class="form-control"
                                        style="width: 100px" />  --> {{ input.dedi09 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="number" v-model="input.dedi10" class="form-control"
                                        style="width: 100px" /> --> {{ input.dedi10 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.dedi11" class="form-control"
                                        style="width: 100px" /> --> {{ input.dedi11 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.dedi12" class="form-control"
                                        style="width: 100px" /> --> {{ input.dedi12 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.dedi13" class="form-control"
                                        style="width: 100px" /> --> {{ input.dedi13 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.dedi14" class="form-control"
                                        style="width: 100px" /> --> {{ input.dedi14 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.dedi15" class="form-control"
                                        style="width: 100px" /> --> {{ input.dedi15 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.dedi16" class="form-control"
                                        style="width: 100px" /> --> {{ input.dedi16 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.dedi17" class="form-control"
                                        style="width: 100px" /> --> {{ input.dedi17 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.dedi18" class="form-control"
                                        style="width: 100px" /> --> {{ input.dedi18 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.dedi19" class="form-control"
                                        style="width: 100px" />  --> {{ input.dedi19 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.dedi20" class="form-control"
                                        style="width: 100px" /> --> {{ input.dedi20 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.noteText" class="form-control"
                                        style="width: 100px" /> --> {{ input.noteText }}
                                    </td>


                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.containerId" class="form-control"
                                        style="width: 100px" /> --> {{ input.containerId }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.udf01" class="form-control"
                                        style="width: 100px" /> --> {{ input.userDefine1 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.udf02" class="form-control"
                                        style="width: 100px" /> --> {{ input.userDefine2 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.udf03" class="form-control"
                                        style="width: 100px" /> --> {{ input.userDefine3 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.udf04" class="form-control"
                                        style="width: 100px" /> --> {{ input.userDefine4 }}
                                    </td>

                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.udf05" class="form-control"
                                        style="width: 100px" /> --> {{ input.userDefine5 }}
                                    </td>


                                    <td>
                                      <!-- <input readonly  type="text" v-model="input.udf05" class="form-control"
                                        style="width: 100px" /> --> {{ input.userDefine6 }}
                                    </td>


                                  </tr>
                                </tbody>

                                <tfoot></tfoot>
                              </table>
                            </div>
                          </div>
                        </div>


                      </div>
                      <div class="tab-pane fade" id="supplier" role="tabpanel" aria-labelledby="supplier-line-tab">
                        <div class="row mb-2">

                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label required">Supplier Id</label>
                            <input readonly type="text" class="form-control" id="supplierId" placeholder="Supplier ID"
                              v-model="forms.supplierId" />
                            <div v-if="errors.supplierId">
                              <div v-for="error in errors.supplierId" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label required">Supplier Name</label>
                            <input readonly type="text" class="form-control" id="supplierName" placeholder="Supplier Name"
                              v-model="forms.supplierName" />
                            <div v-if="errors.supplierName">
                              <div v-for="error in errors.supplierName" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-5">
                            <label for="defaultconfig" class="col-form-label">Supplier Email</label>
                            <input readonly type="text" class="form-control" id="supplierMail"
                              placeholder="Supplier Email" v-model="forms.supplierMail" />

                            <div v-if="errors.supplierMail">
                              <div v-for="error in errors.supplierMail" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                        </div>

                        <div class="row mb-2">
                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Country</label>
                            <input readonly type="text" class="form-control" id="supplierCountry"
                              placeholder="Supllier Country" v-model="forms.supplierCountry" />

                            <div v-if="errors.supplierCountry">
                              <div v-for="error in errors.supplierCountry" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Province</label>
                            <input readonly type="text" class="form-control" id="supplierProvince" placeholder="Province"
                              v-model="forms.supplierProvince" />

                            <div v-if="errors.supplierProvince">
                              <div v-for="error in errors.supplierProvince" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">City</label>
                            <input readonly type="text" class="form-control" id="supplierCity" placeholder="City"
                              v-model="forms.supplierCity" />

                            <div v-if="errors.supplierCity">
                              <div v-for="error in errors.supplierCity" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">District</label>
                            <input readonly type="text" class="form-control" id="supplierDistrict"
                              placeholder="Supplier District" v-model="forms.supplierDistrict" />

                            <div v-if="errors.supplierDistrict">
                              <div v-for="error in errors.supplierDistrict" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Street</label>
                            <input readonly type="text" class="form-control" id="supplierStreet"
                              placeholder="Supplier Street" v-model="forms.supplierStreet" />

                            <div v-if="errors.supplierStreet">
                              <div v-for="error in errors.supplierStreet" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Zip</label>
                            <input readonly type="text" class="form-control" id="supplierZip" placeholder="Supplier Zip"
                              v-model="forms.supplierZip" />

                            <div v-if="errors.supplierZip">
                              <div v-for="error in errors.supplierZip" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                        </div>

                        <div class="row mb-2">

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label required">Contact</label>
                            <input readonly type="text" class="form-control" id="supplierContact"
                              placeholder="Supplier Contact" v-model="forms.supplierContact" />

                            <div v-if="errors.supplierContact">
                              <div v-for="error in errors.supplierContact" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label required">Phone 1</label>
                            <input readonly type="text" class="form-control" id="supplierTel1" placeholder="Phone 1"
                              v-model="forms.supplierTel1" />

                            <div v-if="errors.supplierTel1">
                              <div v-for="error in errors.supplierTel1" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Phone 2</label>
                            <input readonly type="text" class="form-control" id="supplierTel2" placeholder=" Phone 2"
                              v-model="forms.supplierTel2" />

                            <div v-if="errors.supplierTel2">
                              <div v-for="error in errors.supplierTel2" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-6">
                            <label for="defaultconfig" class="col-form-label required">Supplier Address 1</label>
                            <input readonly type="text" class="form-control" id="supplierAddress1" placeholder="Address"
                              v-model="forms.supplierAddress1" />

                            <div v-if="errors.supplierAddress1">
                              <div v-for="error in errors.supplierAddress1" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>




                        </div>

                        <div class="row mb-2">
                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label">Supplier Address 2</label>
                            <input readonly type="text" class="form-control" id="supplierAddress2" placeholder="Address"
                              v-model="forms.supplierAddress2" />

                            <div v-if="errors.supplierAddress2">
                              <div v-for="error in errors.supplierAddress2" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label">Supplier Address 3</label>
                            <input readonly type="text" class="form-control" id="supplierAddress3" placeholder="Address"
                              v-model="forms.supplierAddress3" />

                            <div v-if="errors.supplierAddress3">
                              <div v-for="error in errors.supplierAddress3" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-4">
                            <label for="defaultconfig" class="col-form-label">Supplier Address 4</label>
                            <input readonly type="text" class="form-control" id="supplierAddress4" placeholder="Address"
                              v-model="forms.supplierAddress4" />

                            <div v-if="errors.supplierAddress4">
                              <div v-for="error in errors.supplierAddress4" :key="error" class="alert alert-primary"
                                role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                        </div>









                      </div>

                      <div class="tab-pane fade" readonly id="userDefine" role="tabpanel" aria-labelledby="userDefine-line-tab">

                        
                        <div class="row mb-3">
                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label">UDF 1</label>
                            <input type="text" class="form-control" readonly id="userDefine1" placeholder="" v-model="forms.userDefine1" />
                            <div v-if="errors.userDefine1">
                              <div v-for="error in errors.userDefine1" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">UDF 2</label>
                            <input type="text" class="form-control" readonly id="userDefine2" placeholder="" v-model="forms.userDefine2" />
                            <div v-if="errors.userDefine2">
                              <div v-for="error in errors.userDefine2" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">UDF 3</label>
                            <input type="text" class="form-control" readonly id="userDefine3" placeholder="" v-model="forms.userDefine3" />
                            <div v-if="errors.userDefine3">
                              <div v-for="error in errors.userDefine3" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">UDF 4</label>
                            <input type="text" class="form-control" readonly id="userDefine4" placeholder="" v-model="forms.userDefine4" />
                            <div v-if="errors.userDefine4">
                              <div v-for="error in errors.userDefine4" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label">UDF 5</label>
                            <input type="text" class="form-control" readonly id="userDefine5" placeholder="" v-model="forms.userDefine5" />
                            <div v-if="errors.userDefine5">
                              <div v-for="error in errors.userDefine5" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                        </div>


                        <div class="row mb-3">
                         

                          

                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label">UDF 6</label>
                            <input type="text" class="form-control" readonly id="userDefine6" placeholder="" v-model="forms.userDefine6" />
                            <div v-if="errors.userDefine6">
                              <div v-for="error in errors.userDefine6" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">UDF 7</label>
                            <input type="text" class="form-control" readonly id="userDefine7" placeholder="" v-model="forms.userDefine7" />
                            <div v-if="errors.userDefine7">
                              <div v-for="error in errors.userDefine7" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">UDF 8</label>
                            <input type="text" class="form-control" readonly id="userDefine8" placeholder="" v-model="forms.userDefine8" />
                            <div v-if="errors.userDefine8">
                              <div v-for="error in errors.userDefine8" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>



                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">UDF 9</label>
                            <input type="text" class="form-control" readonly id="userDefine9" placeholder="" v-model="forms.userDefine9" />
                            <div v-if="errors.userDefine9">
                              <div v-for="error in errors.userDefine9" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">UDF 10</label>
                            <input type="text" class="form-control" readonly id="userDefine10" placeholder="" v-model="forms.userDefine10" />
                            <div v-if="errors.userDefine10">
                              <div v-for="error in errors.userDefine10" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                        </div>



                      </div>



                      <div class="tab-pane fade show" id="other" role="tabpanel" aria-labelledby="other-line-tab">
                        <div class="row mb-3">
                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label">Hedi01</label>
                            <input readonly type="text" class="form-control" id="hedi01" placeholder=""
                              v-model="forms.hedi01" />

                            <div v-if="errors.hedi01">
                              <div v-for="error in errors.hedi01" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Hedi02</label>
                            <input readonly type="text" class="form-control" id="hedi02" placeholder=""
                              v-model="forms.hedi02" />

                            <div v-if="errors.hedi02">
                              <div v-for="error in errors.hedi02" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Hedi03</label>
                            <input readonly type="text" class="form-control" id="hedi02" placeholder=""
                              v-model="forms.hedi03" />

                            <div v-if="errors.hedi03">
                              <div v-for="error in errors.hedi03" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Hedi04</label>
                            <input readonly type="text" class="form-control" id="hedi04" placeholder=""
                              v-model="forms.hedi04" />

                            <div v-if="errors.hedi04">
                              <div v-for="error in errors.hedi04" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label">Hedi05</label>
                            <input readonly type="text" class="form-control" id="hedi05" placeholder=""
                              v-model="forms.hedi05" />

                            <div v-if="errors.hedi05">
                              <div v-for="error in errors.hedi05" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                        </div>



                        <div class="row mb-3">
                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label">Hedi06</label>
                            <input readonly type="text" class="form-control" id="hedi01" placeholder=""
                              v-model="forms.hedi06" />

                            <div v-if="errors.hedi06">
                              <div v-for="error in errors.hedi06" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>

                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Hedi07</label>
                            <input readonly type="text" class="form-control" id="hedi02" placeholder=""
                              v-model="forms.hedi07" />

                            <div v-if="errors.hedi07">
                              <div v-for="error in errors.hedi07" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Hedi08</label>
                            <input readonly type="text" class="form-control" id="hedi08" placeholder=""
                              v-model="forms.hedi08" />

                            <div v-if="errors.hedi08">
                              <div v-for="error in errors.hedi08" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-2">
                            <label for="defaultconfig" class="col-form-label">Hedi09</label>
                            <input readonly type="text" class="form-control" id="hedi09" placeholder=""
                              v-model="forms.hedi09" />

                            <div v-if="errors.hedi11">
                              <div v-for="error in errors.hedi09" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                          <div class="col-lg-3">
                            <label for="defaultconfig" class="col-form-label">Hedi10</label>
                            <input readonly type="text" class="form-control" id="hedi10" placeholder=""
                              v-model="forms.hedi10" />

                            <div v-if="errors.hedi10">
                              <div v-for="error in errors.hedi10" :key="error" class="alert alert-primary" role="alert">
                                <i data-feather="alert-circle"></i>
                                {{ error }}
                              </div>
                            </div>
                          </div>


                        </div>


                      </div>





                    </div>




                    <div class="card-footer">
                      <button class="
                            btn btn-warning
                            text-black
                            fw-bolder
                            btn-icon-text
                          " @click="backForm" type="button">
                        <i class="link-icon" data-feather="arrow-left"></i>
                        {{ $t("backMess") }}
                      </button>
                      &nbsp;&nbsp;&nbsp;

                      <div class="float-end">
                        <a href="#" class="btn btn-primary btn-sm "
                          v-if="forms.orderStatus == 'DRAFT' || forms.orderStatus == 'SYNC FAILED'"
                          @click="updateStatus(forms.idAsnHeader)">
                          {{ $t("submitFormTxt") }}
                          <i class="link-icon" data-feather="save"></i>
                        </a>
                        &nbsp;&nbsp;&nbsp;
                        <a href="#" class="btn btn-danger btn-sm "
                          v-if="forms.orderStatus == 'DRAFT' || forms.orderStatus == 'NEW' || forms.orderStatus == 'RECEIVING' || forms.orderStatus=='PACKING'"
                          @click="cancelStatus(forms.idAsnHeader)">
                          {{ $t("cancel_order_txt") }}
                          <i class="link-icon" data-feather="close"></i>
                        </a>

                        &nbsp;&nbsp;&nbsp;
                        <a href="#" class="btn btn-warning btn-sm "
                          v-if="forms.orderStatus == 'CANCELLED' || forms.orderStatus == 'NEW' || forms.orderStatus == 'RECEIVING'"
                          @click="reactedStatus(forms.idAsnHeader)">
                          {{ $t("draft_order_txt") }}
                          <i class="link-icon" data-feather="close"></i>
                        </a>


                        &nbsp;&nbsp;&nbsp;
                        <a href="#" class="btn btn-secondary btn-sm " v-if="forms.orderStatus == 'DRAFT'"
                          @click="editOrder(forms.idAsnHeader)">
                          {{ $t("edit_order_txt") }}
                          <i class="link-icon" data-feather="edit"></i>
                        </a>


                        &nbsp;&nbsp;&nbsp;


                        <button type="button" v-if="forms.orderStatus == 'RECEIVING'" class="btn btn-secondary"
                          @click="manualShipped()">
                          <i class="link-icon" data-feather="edit"></i>
                          Manual Shipped
                        </button>


                        &nbsp;&nbsp;&nbsp;

                        <!-- PACKING','PACKING COMPLETED','SHIPPED' -->
                          <button type="button" v-if="forms.orderStatus == 'RECEIVING' || forms.orderStatus == 'RECEIVED'" class="btn btn-secondary"
                            @click="interfaceBtn(forms.idAsnHeader)">
                            <i class="link-icon" data-feather="edit"></i>
                            Interface
                          </button>

                      </div>

                    </div>
                  </form>

                </div>
              </div> <!--end::card-->
            </div>
          </div>

          <modal name="modalOrderTracking" :draggable="false" :scrollable="true" :height="'auto'">
            <div class="modal fade show" tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true"
              role="dialog">
              <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">

                  <div class="modal-header">
                    <h5 class="modal-title" id="massUploadMasterSKU">Tracking Order Status</h5>
                    <button type="button" class="btn-close" aria-label="btn-close"
                      @click.prevent="removeModals()"></button>
                  </div>
                  <div class="modal-body">
                    <div class="table-responsive" v-if="!isLoadingStatus">
                      <table class="table table-hover">
                        <thead>
                          <th>PIC</th>
                          <th>Status</th>
                          <th>Remarks</th>
                          <th>Update Time</th>
                        </thead>
                        <tbody>
                          <tr v-for="(trackingOrderStatus, index) in trackingOrderStatus " :key="index">
                            <th>{{ trackingOrderStatus.addWho }}</th>
                            <th>{{ trackingOrderStatus.orderStatus }}</th>
                            <th>{{ trackingOrderStatus.remarks }}</th>
                            <th>{{ format_date(trackingOrderStatus.editTime) }}</th>
                          </tr>
                        </tbody>
                      </table>
                    </div>


                    <div v-else class="d-flex align-items-center">
                      <div class="spinner-border ms-auto" role="status" aria-hidden="true"></div>
                      <strong>{{ $t("loadingTxt") }}...</strong>
                    </div>


                  </div>
                  <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{
                      this.$t("close_txt") }}</button>

                  </div>

                </div>
              </div>
            </div>
          </modal>


          <manualShipped :showModal="showModalNow" :data="forms.po_details" :idAsnHeader="forms.idAsnHeader"
            @closeModal="closeMyModal"></manualShipped>



        </div>
        <!--end::content-->

        <!--begin::footer-->
        <footer-component></footer-component>
        <!--end::footer-->
      </div>
    </div>
  </div>
</template>
  
  
<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import manualShipped from "@/components/flux_oms/asn/ModalManualShipped"
// import DateRangePicker from "vue2-daterange-picker";
// import multiselect from "vue-multiselect";

export default {
  name: "CmlTarifAdd",
  props: {},
  components: {
    "navbar-component": navbarComponent,
    "footer-component": footerComponent,
    manualShipped
    // DateRangePicker,
    // multiselect
  },
  data() {
    const startDate = new Date();// new Date();
    const endDate = new Date();

    return {
      dateFilter: {
        startDate,
        endDate,
      },
      asnType: [],
      fetchAsnType: [],
      trackingOrderStatus: [],

      expectedShipmentTime1dateFilter: {
        startDate,
        endDate,
      },

      showModalNow: false,

      opens: "center",
      locale: {
        format: "yyyy-mm-dd H:MM:ss",
      },

      localeDetail: {
        format: "yyyy-mm-dd",
      },

      highlighted: {

        dates: [ // Highlight an array of dates
          new Date(),
        ],

      },

      digit: {
        decimal: ',',
        thousands: '.',
        prefix: ' ',
        suffix: '',
        precision: 5,
        masked: false
      },
      fetchStockCondition: [],
      detailAsn: [],
      orderType: '',
      fetchOrderType: [],
      shelfLifeUnit: {},
      shelfLifeType: {},
      permision_role: [],
      isLoading: false,
      maxToasts: 100,
      position: "up right",
      closeBtn: true,
      errors: [],
      userData: "",
      userRole: "",
      companyCode: "",
      fetchStatus: ['ACTIVE', 'DEACTIVE'],
      fetchmultiWhFlag: ['Y', 'N'],
      fetchCustomer: [],
      fetchFulfillment: [],
      customer: "",
      fulfillment: "",
      fetchShelfLifeType: [],
      fetchShelfLifeUnit: [],
      fetchSku: [],
      activeFlag: false,
      shelfLifeFlag: false,
      kitFlag: false,
      freePickGift: false,
      isLoadingStatus: false,
      forms: {},
    };
  },
  watch: {},
  methods: {



    loadCustomer() {

      const baseURI = this.$settings.endPointFluxOms + "v2/customer/get-data-company-oms";

      return this.$http
        .get(
          baseURI, { timeout: 10000 }
        )
        .then((response) => {
          this.fetchCustomer = response.data.datas.data;
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },




    loadFullfilment() {

      const baseURI = this.$settings.endPointFluxOms + "v2/fulfillment/get-data-fulfillment";

      return this.$http
        .get(
          baseURI, { timeout: 10000 }
        )
        .then((response) => {
          this.fetchFulfillment = response.data.datas.data;
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },


    loadOrderType() {
      const baseURI = this.$settings.endPointFluxOms + "v2/sku/get-data-wms-code?type=SO_TYP";
      return this.$http
        .get(
          baseURI, { timeout: 10000 }
        )
        .then((response) => {
          this.fetchOrderType = response.data.datas.data;
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },


    loadStockCondition() {
      const baseURI = this.$settings.endPointFluxOms + "v2/sku/get-data-wms-code?type=DMG_FLG";
      return this.$http
        .get(
          baseURI, { timeout: 10000 }
        )
        .then((response) => {
          this.fetchStockCondition = response.data.datas.data;
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },



    // asyncSearchSku(ev) {
    //   console.log();
    // // this.fetchSku=[];
    // // const baseURI = this.$settings.endPointFluxOms + "v2/sku/get-data-sku?sku=" + ev;

    // // return this.$http
    // //   .get(
    // //     baseURI, { timeout: 10000 }
    // //   )
    // //   .then((response) => {
    // //     this.fetchSku = response.data.datas;
    // //   }).catch(error => {

    // //     if (error.code == "ECONNABORTED") {
    // //       this.error("Please Check Your Internet Connection");
    // //     }

    // //   });
    // },


    closeMyModal() {
      this.showModalNow = false;
      this.loadData(this.forms.idAsnHeader);
    },

    updateStatus(id) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: 'Submit Status Order',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            orderStatus: 'NEW',
          };
          const baseURI =
            this.$settings.endPointFluxOms + "v2/asn/submitted/" + id;
          this.$http
            .get(baseURI, formData, { timeout: 10000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                window.location.href = "/flux-oms/asn-inbound/";
                //   this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            }).catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));

              } else {


                if (error.code == "ECONNABORTED") {
                  this.error(this.$t("check_internet_connection_txt"));

                } else {

                  if (error.response) {
                    if (error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                      this.logout();
                    } else if (error.response.status === 403) {
                      this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                      this.$router.push('/server-error');
                    } else {
                      this.$router.push('/page-not-found');
                    }
                  }

                }

              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    editOrder(id) {
      var params = this.$onRandom(id);
      window.location.href = "/flux-oms/asn-inbound/edit/" + params;
    },


    manualShipped() {
      this.showModalNow = !this.showModalNow;
      console.log(this.showModalNow);
    },


    reactedStatus(id) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: 'For Reacted ?',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          // var formData = {};
          const baseURI =
            this.$settings.endPointFluxOms + "v2/asn/reacted/" + id;
          this.$http
            .get(baseURI, { timeout: 10000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                window.location.href = "/flux-oms/asn-inbound/";
                //   this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            }).catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));

              } else {


                if (error.code == "ECONNABORTED") {
                  this.error(this.$t("check_internet_connection_txt"));

                } else {

                  if (error.response) {
                    if (error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                      this.logout();
                    } else if (error.response.status === 403) {
                      this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                      this.$router.push('/server-error');
                    } else {
                      this.$router.push('/page-not-found');
                    }
                  }

                }

              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    cancelStatus(id) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: 'Cancel Status Order',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          // var formData = {};
          const baseURI =
            this.$settings.endPointFluxOms + "v2/asn/cancelled/" + id;
          this.$http
            .get(baseURI, { timeout: 10000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                window.location.href = "/flux-oms/asn-inbound/";
                //   this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            }).catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));

              } else {


                if (error.code == "ECONNABORTED") {
                  this.error(this.$t("check_internet_connection_txt"));

                } else {

                  if (error.response) {
                    if (error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                      this.logout();
                    } else if (error.response.status === 403) {
                      this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                      this.$router.push('/server-error');
                    } else {
                      this.$router.push('/page-not-found');
                    }
                  }

                }

              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },

    orderTracking() {
      // this.isLoadingStatus = true;
      this.$modal.show('modalOrderTracking')

    },


    removeModals() {
      this.$modal.hide('modalOrderTracking')

    },


    interfaceBtn(id) {
      this.$swal({
        title: this.$t("areYouSure"),
        text: 'Update interface',
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes!",
      }).then((result) => {
        if (result.value) {
          var formData = {
            interfaceStatus:0
          }
          const baseURI =
            this.$settings.endPointFluxOms + "v2/asn/interface-status/"+id;
          this.$http
            .patch(baseURI,formData, { timeout: 10000 })
            .then((response) => {
              this.loading();
              if (response.data.status === 200) {
                this.success(response.data.datas.messages);
                window.location.href = "/flux-oms/asn-inbound";
                //   this.loadItems();
              } else {
                this.errors = response.data.errors;
                this.resultError(response.data.errors);
              }
            }).catch((error) => {
              this.loading();

              if (error.code == "ECONNABORTED") {
                this.error(this.$t("check_internet_connection_txt"));

              } else {


                if (error.code == "ECONNABORTED") {
                  this.error(this.$t("check_internet_connection_txt"));

                } else {

                  if (error.response) {
                    if (error.response.status === 422) {
                      this.errors = error.response.data.errors;
                      this.resultError(error.response.data.errors);
                    } else if (error.response.status === 401) {
                      this.logout();
                    } else if (error.response.status === 403) {
                      this.$router.push("/authorized-error");
                    } else if (error.response.status === 500) {
                      this.$router.push('/server-error');
                    } else {
                      this.$router.push('/page-not-found');
                    }
                  }

                }

              }
            });
        } else {
          this.isLoading = false;
        }
      });
    },



    format_date(value) {
      if (value) {
        return this.$moment(String(value)).format('YYYY-MM-DD HH:mm:ss')
      }
    },





    loadData(id) {
      this.isLoading = true;
      const baseURI = this.$settings.endPointFluxOms + "v2/asn/detail/" + id;

      return this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

        this.isLoading = false;
        this.forms = response.data.datas;

        this.customer = {
          code: this.forms.customerId
        };

        this.fulfillment = {
          fulfillment_center_id: this.forms.fulfillment.fulfillment_center_id,
          code:  this.forms.fulfillment.code,
          name: this.forms.fulfillment.name,
        };
        console.log(this.fulfillment);
        this.dateFilter = {
          startDate: this.forms.orderTime,
          endDate: this.forms.orderTime

        },

          this.trackingOrderStatus = this.forms.asn_trackings;


        this.expectedShipmentTime1dateFilter = {
          startDate: this.forms.expectedShipmentTime1,
          endDate: this.forms.expectedShipmentTime1
        },


          this.asnType = {
            code: this.forms.asn_type.code,
            name: this.forms.asn_type.name,
          };

          console.log(this.asnType);

        this.detailAsn = this.forms.asn_details;



        // this.fulfillment    = response.data.datas.fulfillment

      }).catch(error => {

        this.loading();

        if (error.code == "ECONNABORTED") {
          this.error(this.$t("check_internet_connection_txt"));
        } else {

          if (error.response) {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors;
              this.resultError(error.response.data.errors);
            } else if (error.response.status === 401) {
              this.logout();
            } else if (error.response.status === 403) {
              this.$router.push("/authorized-error");
            } else if (error.response.status === 500) {
              this.$router.push('/server-error');
            } else {
              this.$router.push('/page-not-found');
            }
          }

        }

      });
    },

    cekData(index, fieldType) {
      console.log(index);
      console.log(fieldType);
      fieldType[index].skuDescr1 = fieldType[index].sku.skuDescr1;
      // fieldType[index].lading_length = fieldType[index].sku.pcs_length;
      // fieldType[index].lading_width = fieldType[index].sku.pcs_width;
      // fieldType[index].lading_height = fieldType[index].sku.pcs_height;
      // //fieldType[index].package_type = fieldType[index].sku.package_code;    
      // fieldType[index].lading_qty = fieldType[index].sku.lading_qty;
      // fieldType[index].net_weight = fieldType[index].sku.net_weight;
      // fieldType[index].weight = fieldType[index].sku.weight;
      // fieldType[index].volume = fieldType[index].sku.volume;
      // //fieldType[index].qty = 0;  
      // this.loadLadingType(fieldType[index].sku.sku_id);
    },


    asyncSearchFulfillment(ev) {
      this.fetchFulfillment = [];
      const baseURI = this.$settings.endPointFluxOms + "v2/fulfillment/get-data-fulfillment?code=" + ev;

      return this.$http
        .get(
          baseURI, { timeout: 10000 }
        )
        .then((response) => {
          this.fetchFulfillment = response.data.datas.data;
          //console.log(this.fetchFulfillment);
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },


    asyncCustomer(code) {
      this.fetchCustomer = [];
      const baseURI = this.$settings.endPointFluxOms + "v2/customer/get-data-company-oms?code=" + code;

      return this.$http
        .get(
          baseURI, { timeout: 10000 }
        )
        .then((response) => {
          this.fetchCustomer = response.data.datas.data;
        }).catch(error => {

          if (error.code == "ECONNABORTED") {
            this.error("Please Check Your Internet Connection");
          }

        });
    },

    resetForm() {

      this.forms = [];

    },

    fetchIt() {
      const userDatas = this.$getUserInfo();
      this.userData = userDatas.sub;
      this.userRole = userDatas.sub.role;
      // this.permision_role = userDatas.sub.permision_role;
      let rolePermision = [];
      userDatas.sub.permision_role.forEach(function (permision) {
        if (permision.permission.controller == 'AsnController') {
          rolePermision = permision;
          // console.log(permision);
        }
      });

      if (!rolePermision.method_read) {
        this.$router.push("/authorized-error");
      }

      this.permision_role = rolePermision;



      // this.loadShelfLifeType();
      // this.loadShelfLifeUnit();

    },

    backForm() {
      window.location.href = "/flux-oms/asn-inbound";
    },



    submitData() {
      this.isLoading = true;



      this.forms.customer_id = this.customer.customer_id;
      this.forms.customerId = this.customer.code;

      this.forms.fulfillment_center_id = this.fulfillment.fulfillment_center_id;
      this.forms.warehouseId = this.fulfillment.code;
      this.forms.orderType = this.orderType.code;
      this.forms.orderTime = this.$moment(String(this.dateFilter.startDate)).format('YYYY-MM-DD H:mm:ss');
      this.forms.expectedShipmentTime1 = this.$moment(String(this.expectedShipmentTime1dateFilter.startDate)).format('YYYY-MM-DD H:mm:ss');
      var DOC_ORDER_DETAILS = [];


      for (let index = 0; index < this.detailSo.length; index++) {
        const element = {
          "idOrderHeader": index + 1,
          "sku": this.detailSo[index].sku.sku,
          "qtyOrdered": this.detailSo[index].qtyOrdered,
          "StockConditionCode": this.detailSo[index].StockConditionCode.code,
          "price": this.detailSo[index].price,
          "ProdDate": this.$moment(String(this.detailSo[index].ProdDate.startDate)).format('YYYY-MM-DD'),
          "ExpDate": this.$moment(String(this.detailSo[index].ExpDate.startDate)).format('YYYY-MM-DD'),
          "WhseDate": this.$moment(String(this.detailSo[index].WhseDate.startDate)).format('YYYY-MM-DD'),
          "Batch": this.detailSo[index].Batch,
          "lotAtt07": this.detailSo[index].lotAtt07,
          "Uom": this.detailSo[index].Uom,
          "udf01": this.detailSo[index].udf01,
          "noteText": this.detailSo[index].noteText
        }

        DOC_ORDER_DETAILS.push(element);

      }

      this.forms.DOC_ORDER_DETAILS = DOC_ORDER_DETAILS;

      console.log(this.forms);
      const baseURI = this.$settings.endPointFluxOms + "v2/asn/store";
      this.$http.post(baseURI, this.forms, { timeout: 10000 }).then((response) => {
        this.loading();
        if (response.data.status === 200) {
          //this.resetForm();
          this.isLoading = false;
          this.errors = [];
          //console.log(response.data.datas.user_id);
          //var params = this.$onRandom(response.data.datas.BAS_SKU_ID);
          window.location.href = "/flux-oms/asn-inbound";
          this.success('Berhasil');
        } else {
          this.isLoading = false;
          this.errors = response.data.errors;
          this.resultError(response.data.errors);
        }
      }).catch(error => {
        this.loading();
        this.isLoading = false;
        if (error.code == "ECONNABORTED") {
          this.error("Please Check Your Internet Connection");
        }

        if (error.response) {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            this.resultError(error.response.data.errors);
          } else if (error.response.status === 401) {
            this.logout();
          } else if (error.response.status === 403) {
            this.$router.push("/authorized-error");
          } else if (error.response.status === 500) {
            this.$router.push('/server-error');
          } else {
            this.$router.push('/page-not-found');
          }
        }
        //this.resetForm();
      });

    },


    addFieldDetail() {
      const startDate = new Date();// new Date();
      const endDate = new Date();
      this.detailSo.push({
        "customerId": this.forms?.customerId,
        "warehouseId": this.forms?.fulfillment_center_id,
        "orderNo": this.forms?.orderNo,
        "sku": "",
        "skuDescr1": "",
        "qtyOrdered": 0,
        "StockConditionCode": '',
        "price": 0,
        "ProdDate": {
          startDate,
          endDate,
        },
        "ExpDate": {
          startDate,
          endDate,
        },
        "WhseDate": {
          startDate,
          endDate,
        },
        "Batch": "",
        "lotAtt07": "",
        "Uom": "",
        "udf01": "",
        "noteText": ""
      });

      console.log(this.detailSo);
    },

    removeField(index, fieldType) {
      fieldType.splice(index, 1);
    },

    logout() {

      const baseURI = this.$settings.endPoint + "user/logout";
      this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

        console.log(response);

      });

      this.$logoutUser();
      window.location.href = '/';
    },

    fade(sType) {
      this.isLoading = sType;
    },

    loading() {
      this.fade(true);
      setTimeout(() => {
        this.fade(false);
      }, 1000); // hide the message after 3 seconds
    },

    resultError(data) {
      var count = Object.keys(data).length;
      for (var x = 0; x < count; x++) {
        var nameOb = Object.keys(data)[x];
        var objectData = data[nameOb];
        for (var y = 0; y < objectData.length; y++) {
          this.error(objectData[y]);
        }
      }
    },

    success(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "success",
        title: kata,
      });
    },

    error(kata) {
      const Toast = this.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener("mouseenter", this.$swal.stopTimer);
          toast.addEventListener("mouseleave", this.$swal.resumeTimer);
        },
      });
      Toast.fire({
        icon: "error",
        title: kata,
      });
    },
  },
  events: {},
  created: function () { },
  mounted() {
    this.fetchIt();

    var params = this.$onBehind(this.$route.params.id);

    this.loadData(params[0]);


  },
};
</script>
<style scoped>.required:after {
  content: " *";
  color: red;
}</style>